import React, { useMemo } from 'react';

import MainPage from './components/MainPage';
import Users from './components/Users';
import LoginCodes from './components/LoginCodes';
import OrderShipments from './components/OrderShipments';
import Batches from './components/Batches';
import BatchDetail from './components/Batches/BatchDetail';
import Returns from './components/Returns';
import History from './components/History';

import Settings from './components/Settings';

import CartLayouts from './components/CartLayouts';
import NewCartLayoutForm from './components/CartLayouts/NewCartLayoutForm';
import UpdateCartLayoutForm from './components/CartLayouts/UpdateCartLayoutForm';

import Rules from './components/Rules';
import RuleForm from './components/Rules/RuleForm';

import WarehouseLanding from './components/Warehouse';
import WarehouseApp from './components/Warehouse/WarehouseApp';

import AdminGate from './components/AdminGate';
import NavMenu from './components/NavMenu';

import { Frame } from '@shopify/polaris';

import {
  createBrowserRouter,
  RouterProvider,
  Outlet
} from 'react-router-dom';

// Admin pages share the Polaris frame with the sidebar nav; the warehouse
// app keeps its own chrome.
const AdminLayout = () => (
  <Frame navigation={<NavMenu />}>
    <AdminGate>
      <Outlet />
    </AdminGate>
  </Frame>
);

const App = () => {
  // A data router (not BrowserRouter) is required for useBlocker, which
  // the ported warehouse work screens use for their leave-confirmation
  // popups on every kind of navigation
  const router = useMemo(() => createBrowserRouter([
    {
      element: <AdminLayout />,
      children: [
        { path: '/', element: <MainPage /> },
        { path: '/settings', element: <Settings /> },
        { path: '/cart_layouts', element: <CartLayouts /> },
        { path: '/cart_layouts/new', element: <NewCartLayoutForm /> },
        { path: '/cart_layouts/edit/:id', element: <UpdateCartLayoutForm /> },
        { path: '/users', element: <Users /> },
        { path: '/login_codes', element: <LoginCodes /> },
        { path: '/order_shipments', element: <OrderShipments /> },
        { path: '/batches', element: <Batches /> },
        { path: '/batches/:id', element: <BatchDetail /> },
        { path: '/returns', element: <Returns /> },
        { path: '/history', element: <History /> },
        { path: '/rules', element: <Rules /> },
        { path: '/rules/new', element: <RuleForm /> },
        { path: '/rules/edit/:id', element: <RuleForm /> },
        { path: '/warehouse', element: <WarehouseLanding /> },
      ]
    },
    { path: '/warehouse/app/*', element: <WarehouseApp /> },
  ]), []);

  return (
    <div>
      <RouterProvider router={router} />
    </div>
  )
}

export default App;
